import React from 'react';
import { motion } from 'framer-motion';
import { Box, Container, Typography, Grid } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

export default function WhyChooseUs() {
  const features = [
    {
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      title: "Expert Qualified Team",
      description: "Qualified and Experienced Professionals",
    },
    {
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      title: "Timely Service",
      description: "Quick turnaround time for GST, income tax, and business registrations",
    },
    {
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      title: "Affordable Pricing",
      description: "Competitive rates for all services",
    },
    {
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      title: "Personalized Support",
      description: "Dedicated support for your business needs",
    },
    {
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      title: "Complete Compliance",
      description: "Ensure 100% compliance with tax and business regulations",
    },
    {
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      title: "Loan Assistance",
      description: "The Best Advisory Services in Term Loan, CC & OD.",
    },
  ];

  return (
    <Box component="section" sx={{ py: { xs: 10, md: 12 }, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Typography
            variant="h3"
            component="h2"
            sx={{ textAlign: 'center', fontWeight: 'bold', mb: 8, fontSize: { xs: '2rem', md: '2.5rem' } }}
          >
            Why Choose SHREE CONSULTANCY?
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {features.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(30, 91, 92, 0.1)',
                      color: 'rgba(30, 91, 92, 1)',
                      flexShrink: 0
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}